// extracted by mini-css-extract-plugin
export default {"Header":"WZplG6EarD_W66Mleis5","Item":"QNIWhpS6LZi6Fuaw2dFd"};